/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './image-cloudinary.stache';
import cloudinaryUtil from 'scripts/utils/cloudinary';
import can from 'can';
import canUtil from 'scripts/utils/can';
import domUtil from 'scripts/utils/dom';
import 'can/util/function/function';
import DomEventsManager from 'scripts/dom-events-manager';

Component.extend({
    tag: 'image-cloudinary',
    template: template,
    viewModel: {
        visible: false,
        autoShow: true,
        image: {},
        id: 0,
        crop: '',
        width: 0,
        height: 0,
        className: '',
        gravity: '',
        radius: '',
        alt: '',
        requireSize: false,
        show: function() {
            if (this.attr('autoShow')) {
                this.attr('visible', true);
            }
        },
        recalculateSize: function(element) {
            const $image = can.$(element).find('img');
            $image.removeClass('is-resized');
            this.attr({
                cssWidth: domUtil.getElementCssProperty($image, 'max-width'),
                cssHeight: domUtil.getElementCssProperty($image, 'max-height'),
            });

            $image.addClass('is-resized');
        },
        define: {
            $el: {
                Type: can.Map,
                Value: can.Map,
            },
            aggregate: {
                get: function() {
                    const image = this.attr('image');

                    return {
                        id: this.attr('id') || image.attr('id'),
                        crop: this.attr('crop') || image.attr('crop'),
                        width:
                            this.attr('cssWidth') ||
                            this.attr('width') ||
                            image.attr('width'),
                        height:
                            this.attr('cssHeight') ||
                            this.attr('height') ||
                            image.attr('height'),
                        className:
                            this.attr('className') || image.attr('className'),
                        alt: this.attr('alt') || image.attr('alt'),
                        quality: this.attr('quality') || image.attr('quality'),
                        gravity: this.attr('gravity') || image.attr('gravity'),
                        radius: this.attr('radius') || image.attr('radius'),
                    };
                },
            },
            href: {
                get: canUtil.debouncedGet(
                    'visible',
                    'aggregate',
                    '$el',
                    function(visible, aggregate, $el) {
                        if (visible) {
                            if (
                                this.attr('requireSize') &&
                                (!aggregate.width || !aggregate.height)
                            ) {
                                this.recalculateSize($el);
                            }
                            if (
                                !this.attr('requireSize') ||
                                (this.attr('requireSize') &&
                                    aggregate.width &&
                                    aggregate.height)
                            ) {
                                return cloudinaryUtil.getCloudinaryPath(
                                    aggregate.id,
                                    aggregate.width,
                                    aggregate.height,
                                    aggregate.crop,
                                    aggregate.quality,
                                    aggregate.gravity,
                                    aggregate.radius,
                                );
                            }
                        }
                        return '';
                    },
                    200,
                ),
            },
            swiperDataSrc: {
                get() {
                    const aggregate = this.attr('aggregate');
                    return cloudinaryUtil.getCloudinaryPath(
                        aggregate.id,
                        aggregate.width,
                        aggregate.height,
                        aggregate.crop,
                    );
                },
            },
        },
    },
    helpers: {},
    events: {
        inserted: function() {
            this.viewModel.attr('$el', this.element);
            this.img = new Image();
            this.img.onload = () => {
                this.viewModel.dispatch('cloudinaryImageLoaded');
            };
            this.img.onerror = () => {
                console.warn('Could not load cloudinary image');
                this.viewModel.dispatch('cloudinaryImageLoaded');
            };
            DomEventsManager.subscribe(this);
        },
        removed: function() {
            DomEventsManager.unsubscribe(this);
        },
        onFirstShow: function() {
            this.viewModel.show();
        },
        onLayout: function() {
            this.viewModel.recalculateSize(this.element);
        },
        '{scope} href'(scope, event, href) {
            if (!this.img) {
                return;
            }

            this.img.src = href;
        },
    },
});
